import validBarcode from 'barcode-validator'

export const isEANValid = value => {
  if (value) {
    return validBarcode(value, 'GTIN')
  }
  return true
}
